export interface RankableFreeAgentBid {
  bidAmount: number;
  bidDuration: number;
  $createdAt: string;
}

export const calculateBidValue = (bidAmount: number, duration: number): number => {
  const multiplier = 1 + (duration - 1) * 0.18;
  return bidAmount * multiplier;
};

// Sorts the best bid first. For $0 bids, duration is the value tie-breaker.
export const compareFreeAgentBids = <T extends RankableFreeAgentBid>(a: T, b: T): number => {
  const valueDifference = calculateBidValue(b.bidAmount, b.bidDuration)
    - calculateBidValue(a.bidAmount, a.bidDuration);

  if (valueDifference !== 0) {
    return valueDifference;
  }

  if (a.bidAmount === 0 && b.bidAmount === 0 && a.bidDuration !== b.bidDuration) {
    return b.bidDuration - a.bidDuration;
  }

  return new Date(b.$createdAt).getTime() - new Date(a.$createdAt).getTime();
};
